import React from 'react';
import PropTypes from 'prop-types';

export const SvgTrend = ({ width, height, stroke, direction = 'up' }) => (
  <svg
    width={width || '17px'}
    height={height || '10px'}
    viewBox="0 0 17 10"
    version="1.1"
    style={{ transform: `scaleY(${direction === 'down' ? -1 : 1})` }}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinejoin="round">
      <g
        transform="translate(-29.000000, -185.000000)"
        stroke={stroke || '#000000'}
        strokeWidth="2"
      >
        <g transform="translate(15.000000, 170.000000)">
          <g transform="translate(10.000000, 8.000000)">
            <path d="M19.3333333,8 L13,14.3333333 L9.66666667,11 L4.66666667,16 M15.3333333,8 L19.3333333,8 L19.3333333,12" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

SvgTrend.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  stroke: PropTypes.string,
  direction: PropTypes.string,
};
